import '@core/api';
import '@core/resources/registerDocumentThumbnails';
import { normalizeHashRouterUrl } from '@core/routing/normalizeHashRouterUrl';
import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './app/App';
import reportWebVitals from './reportWebVitals';

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;

if (!import.meta.env.DEV && sentryDsn !== undefined && sentryDsn !== '') {
    Sentry.init({
        dsn: sentryDsn,
        environment: import.meta.env.VARIANT_NAME,
    });
}

normalizeHashRouterUrl();

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
